"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/GUFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_97)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_97`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M-5.22107 0.779053H29.1438V23.172H-5.22107V0.779053Z",
					fill: "#0052B4"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 20.0212C11.9649 20.0212 17.3263 16.4212 17.3263 11.9791C17.3263 7.53695 11.9649 3.92993 11.9649 3.92993C11.9649 3.92993 6.60352 7.52993 6.60352 11.972C6.60352 16.4141 11.9649 20.0212 11.9649 20.0212Z",
					fill: "#7DBEF1"
				}),
				/* @__PURE__ */ n("path", {
					d: "M6.61755 12.6807H17.3263L15.2702 17.2351H8.58948L6.61755 12.6807Z",
					fill: "#1C8AE6"
				}),
				/* @__PURE__ */ n("path", {
					d: "M7.49475 14.4492C7.49475 14.4492 10.3369 17.1299 11.0737 17.1299C11.9439 17.1299 11.9579 15.8387 12.8632 15.3404C14.2807 14.5615 16.4421 14.4492 16.4421 14.4492L14.8421 17.4527L11.9649 20.0211L8.68072 17.2352L7.49475 14.4492Z",
					fill: "#FFF042"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 11.0527L10.386 12.1475L10.9403 10.3089L9.41052 9.15097L11.3333 9.11588L11.9649 7.29834L12.5965 9.11588L14.5193 9.15097L12.9895 10.3159L13.5439 12.1545L11.9649 11.0527Z",
					fill: "#259C7B"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.5228 10.1474C11.4597 10.7931 11.4176 11.4387 11.4035 12.0843C11.3825 12.9194 11.4246 13.5369 11.5439 13.9088C11.6983 14.372 12.0491 14.8141 12.5404 15.2352C12.9123 15.558 13.2842 15.8036 13.5368 15.9439C13.7544 16.0632 14.0281 15.986 14.1474 15.7755C14.2667 15.558 14.1895 15.2843 13.979 15.165C13.6772 14.9895 13.3895 14.786 13.1228 14.5545C12.7439 14.2317 12.4842 13.9088 12.393 13.6211C12.3158 13.3825 12.2807 12.8281 12.2947 12.0983C12.3088 11.4738 12.3509 10.8492 12.414 10.2317C12.4421 9.98604 12.2597 9.76849 12.014 9.74042C11.7614 9.71937 11.5439 9.90183 11.5228 10.1474Z",
					fill: "#8E5715"
				}),
				/* @__PURE__ */ n("path", {
					d: "M9.28418 11.979L11.0737 14.6597H9.28418V11.979Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M11.9649 20.0212C11.9649 20.0212 17.3263 16.4212 17.3263 11.9791C17.3263 7.53695 11.9649 3.92993 11.9649 3.92993C11.9649 3.92993 6.60352 7.52993 6.60352 11.972C6.60352 16.4141 11.9649 20.0212 11.9649 20.0212Z",
					stroke: "#D80027",
					strokeWidth: .842105,
					strokeMiterlimit: 10
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_97`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as GUFlag };
